<div class="flex justify-between items-center w-full">
	<div *ngIf="!selectedChecklist">
		<p class="text-xl font-bold">Add new template</p>
		<p class="text-grey-dark">Create a checklist for a file type</p>
	</div>
	<div *ngIf="selectedChecklist" class="flex items-center gap-6">
		<app-matter-type-icon [fileType]="selectedFileType"></app-matter-type-icon>
		<div>
			<p class="text-lg font-bold">{{ templateName }}</p>
			<p class="text-grey text-sm">
				{{ selectedChecklist?.locked ? 'Closer default' : 'Business name' }}
				<app-icon
					*ngIf="selectedChecklist?.locked"
					[icon]="ICON.LOCK"
				></app-icon>
			</p>
		</div>
	</div>
	<div
		*ngIf="step === 2 && stages.length > 0 && editable && editing"
		class="flex items-center gap-2"
	>
		<app-button btn="border" [icon]="ICON.CHECKLIST" (click)="addStage()"
			>Add stage</app-button
		>
		<app-button btn="border" [icon]="ICON.ADD" (click)="addTask()"
			>Add task</app-button
		>
	</div>
</div>

<form
	#myForm="ngForm"
	(ngSubmit)="nextStep(myForm.form)"
	class="flex flex-col gap-6 mt-6 w-[500px]"
	*ngIf="step === 1"
>
	<app-input
		label="Checklist name"
		name="checklistName"
		[(ngModel)]="templateName"
		[required]="true"
	></app-input>

	<div>
		<p class="text-lg">Select a file type for this template</p>
		<p class="text-grey text-sm">Select one</p>
		<div class="flex items-center gap-2 mt-2">
			<app-pill
				class="cursor-pointer"
				[mode]="
					selectedFileType === MatterFileType.SALE
						? 'activeStatus'
						: 'inactiveStatus'
				"
				(click)="selectFileType(MatterFileType.SALE)"
				>Sale</app-pill
			>
			<app-pill
				class="cursor-pointer"
				[mode]="
					selectedFileType === MatterFileType.PURCHASE
						? 'activeStatus'
						: 'inactiveStatus'
				"
				(click)="selectFileType(MatterFileType.PURCHASE)"
				>Purchase</app-pill
			>
			<app-pill
				class="cursor-pointer"
				[mode]="
					selectedFileType === MatterFileType.REFINANCE
						? 'activeStatus'
						: 'inactiveStatus'
				"
				(click)="selectFileType(MatterFileType.REFINANCE)"
				>Refinance</app-pill
			>
		</div>
	</div>

	<div>
		<p class="text-lg">
			Include this template in newly created files by default
		</p>
		<atomic-switch
			name="default"
			[ngModel]="default"
			(ngModelChange)="toggleDefault($event)"
		></atomic-switch>
	</div>

	<div class="flex items-center justify-between">
		<app-button btn="border" (click)="close()">Cancel</app-button>
		<div class="flex items-center gap-2">
			<p class="text-sm text-grey-darker">
				Step <span class="font-bold">1</span> of 2
			</p>
			<app-button btn="primary" type="submit">Next step</app-button>
		</div>
	</div>
</form>

<div *ngIf="step === 2" class="w-[750px] mt-10">
	<div
		class="w-full flex justify-center items-center flex-col gap-2"
		*ngIf="stages.length === 0"
	>
		<div class="w-24 h-24 rounded-full bg-grey-veryLight"></div>
		<p class="font-bold">Start by creating a stage or task</p>
		<div class="flex items-center gap-2">
			<app-button btn="border" [icon]="ICON.CHECKLIST" (click)="addStage()"
				>Add stage</app-button
			>
			<app-button btn="border" [icon]="ICON.ADD" (click)="addTask()"
				>Add task</app-button
			>
		</div>
	</div>

	<div
		*ngIf="stages.length > 0"
		id="dialog-stages-container"
		class="h-[455px] overflow-auto"
		cdkDropList
		[cdkDropListData]="stages"
		(cdkDropListDropped)="dropStage($event)"
		[cdkDropListDisabled]="!editing"
	>
		<div
			*ngFor="
				let stage of stages;
				let i = index;
				let last = last;
				trackBy: stageTracker
			"
			[ngClass]="!last ? 'mb-4' : 'mb-0'"
			cdkDrag
		>
			<div class="flex items-start gap-2 justify-start">
				<div class="self-stretch">
					<div
						class="w-6 h-6 text-sm bg-white flex items-center justify-center text-center rounded-full"
						[ngClass]="
							selectedStageIndex === i
								? 'border-4 border-green-light'
								: 'border-4 border-grey-light'
						"
					>
						<p>{{ i + 1 }}</p>
					</div>
					<div class="flex justify-center w-full h-full">
						<div
							[ngClass]="{
								'vertical-line': true,
								'selected-stage': selectedStageIndex === i,
								last: last,
								opened: stages[i].open,
							}"
						></div>
					</div>
				</div>
				<div class="flex-1">
					<div *ngIf="editingStageIndex === i" class="w-60">
						<app-input
							class="pt-1"
							[autofocus]="true"
							(onBlur)="onInputStageBlur()"
							[ngModel]="stage.title"
							(ngModelChange)="editStageTitle(stage, $event)"
							(keyup.enter)="resetEditingStageIndex()"
						></app-input>
					</div>
					<div
						*ngIf="editingStageIndex !== i"
						class="flex items-center justify-between cursor-pointer"
						(click)="toggleOpen(i)"
					>
						<div class="flex items-center gap-4 w-full hover-container">
							<p class="cursor-pointer text-base font-bold">
								{{ stage.title }}
							</p>
							<div class="items-center gap-2 hover-icons" *ngIf="editing">
								<app-icon
									[icon]="ICON.SORT"
									class="cursor-pointer text-grey-dark"
									cdkDragHandle
								></app-icon>
								<app-icon
									[icon]="ICON.EDIT"
									class="cursor-pointer text-grey-dark"
									(click)="editStage(i)"
								></app-icon>
								<app-icon
									[icon]="ICON.COPY"
									class="cursor-pointer text-grey-dark"
									(click)="duplicateStage(stage)"
								></app-icon>
								<app-icon
									[icon]="ICON.DELETE"
									class="cursor-pointer text-grey-dark"
									(click)="deleteStage(i)"
								></app-icon>
							</div>
						</div>
						<app-icon
							[icon]="stage.open ? ICON.UP : ICON.DOWN"
							class="cursor-pointer"
						></app-icon>
					</div>
					<div
						*ngIf="stage.open"
						[@openClose]
						[id]="getStageId(i, stage)"
						[cdkDropListConnectedTo]="getConnectedStagesIds(i)"
						cdkDropList
						[cdkDropListData]="stage.tasks"
						(cdkDropListDropped)="dropTask($event)"
						[cdkDropListDisabled]="!editing"
						class="min-h-[10px]"
					>
						<div
							*ngFor="
								let task of stage.tasks;
								let taskIndex = index;
								trackBy: taskTracker
							"
							class="my-3"
							cdkDrag
						>
							<div
								*ngIf="
									editingTaskIndex === taskIndex && selectedStageIndex === i
								"
							>
								<app-input
									[autofocus]="true"
									class="pr-1"
									(onBlur)="onInputTaskBlur()"
									[ngModel]="task.title"
									(ngModelChange)="editTaskTitle(stage, task, $event)"
									(keyup.enter)="resetEditingTaskIndex()"
								></app-input>
								<p class="w-full text-right text-sm pr-1">
									Press <span class="font-bold">Enter</span> to save and add
									next task
								</p>
							</div>
							<div
								*ngIf="
									editingTaskIndex !== taskIndex || selectedStageIndex !== i
								"
								class="flex items-center gap-2"
							>
								<app-icon [icon]="ICON.CHECK" class="text-green"></app-icon>
								<div class="flex items-center gap-4 w-full hover-container">
									<p class="text-base">{{ task.title }}</p>
									<div>
										<app-icon
											*ngIf="task.fieldPath"
											class="text-grey-light w-6 h-6"
											[icon]="ICON.INFO_SQUARE"
											matTooltip="Synced with Upcoming Requisitions"
										></app-icon>
									</div>
									<div class="items-center gap-2 hover-icons" *ngIf="editing">
										<app-icon
											[icon]="ICON.SORT"
											class="cursor-pointer text-grey-dark"
											cdkDragHandle
										></app-icon>
										<app-icon
											[icon]="ICON.EDIT"
											class="cursor-pointer text-grey-dark"
											(click)="editTask(i, taskIndex)"
										></app-icon>
										<app-icon
											[icon]="ICON.COPY"
											class="cursor-pointer text-grey-dark"
											(click)="duplicateTask(i, task)"
										></app-icon>
										<app-icon
											[icon]="ICON.DELETE"
											class="cursor-pointer text-grey-dark"
											(click)="deleteTask(i, taskIndex)"
										></app-icon>
									</div>
								</div>
							</div>
						</div>
					</div>
					<p
						*ngIf="editable && editing && stage.open"
						class="text-grey-darker text-xs mt-3 cursor-pointer"
						(click)="addTask(i)"
					>
						<app-icon [icon]="ICON.ADD" class="mr-2"></app-icon>Add task
					</p>
				</div>
			</div>
		</div>
	</div>

	<div class="flex items-center justify-between mt-14">
		<app-button btn="border" (click)="close()">Cancel</app-button>

		<div class="flex items-center gap-2" *ngIf="editing">
			<p class="text-sm text-grey-darker">
				Step <span class="font-bold">2</span> of 2
			</p>
			<app-button btn="tertiary" (click)="previousStep()">Back</app-button>
			<app-button
				btn="border"
				(click)="create(true)"
				*ngIf="!selectedChecklist || selectedChecklist.draft"
				>Save draft</app-button
			>
			<app-button
				[disabled]="!checkIfTaskExists()"
				btn="primary"
				(click)="create(false)"
				>{{
					selectedChecklist && !selectedChecklist.draft ? 'Save' : 'Create'
				}}</app-button
			>
		</div>

		<div class="flex items-center gap-2" *ngIf="!editing">
			<app-button btn="border" [disabled]="!editable" (click)="edit()"
				>Edit</app-button
			>
			<app-button btn="primary" (click)="duplicate()">Duplicate</app-button>
		</div>
	</div>
</div>
